import dynamic from "next/dynamic";
import styled from "styled-components";
import Modal from "react-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

import useStore from "hooks/useStore";

interface Props {
  filterIsOpen: boolean;
  toggleFilter: any;
  applyFilter: () => void;
}

const customStyles: any = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    padding: 0,
    backgroundColor: "rgba(20, 20, 20, 0.7)",
  },
  content: {
    position: "absolute",
    borderRadius: "12px",
    background: "rgb(255, 255, 255)",
    overflow: "none",
    outline: "none",
    left: 0,
    right: 0,
    margin: "0px auto",
    padding: 0,
    width: "600px",
    height: "75vh",
    top: "100px",
  },
};

Modal.setAppElement("#main");
const Checkbox = dynamic(() => import("components/Checkbox"));

const Filter = ({ filterIsOpen, toggleFilter, applyFilter }: Props) => {
  const {
    filterData,
    filterObject,
    filterSearchTerm,
    filterCount,
    setFilter,
    setFilterCount,
    setFilterSearchTerm,
    clearFilter,
  } = useStore();

  const onCheckboxChange = (item: any, key: string) => {
    const copyFilterObject: any = { ...filterObject };

    filterData[key].forEach((data: any) => {
      if (data.id === item.id) {
        if (item.isSelected) {
          setFilterCount(filterCount - 1);
          item.isSelected = false;
          const index = copyFilterObject[key].findIndex(
            (x: any) => x.id === item.id
          );
          copyFilterObject[key].splice(index, 1);
        } else {
          setFilterCount(filterCount + 1);
          item.isSelected = true;
          copyFilterObject[key].push(item.id);
        }
        setFilter(copyFilterObject);
      }
    });
  };

  const onFilterSearchTermChange = (e: any) => {
    setFilterSearchTerm(e.target.value);
  };

  const applyFilterHandler = () => {
    applyFilter();
    toggleFilter();
  }

  return (
    <Modal
      isOpen={filterIsOpen}
      onRequestClose={toggleFilter}
      style={customStyles}
      className="kampp-modal"
      contentLabel="Filter Modal"
      closeTimeoutMS={250}
    >
      <HeaderContainer>
        <CloseIcon onClick={toggleFilter} icon={faTimes} />
        <HeaderTitle> Filtreler</HeaderTitle>
        <Gap />
      </HeaderContainer>
      <ContentContainer>
        <FilterSection>
          <ItemTitle>Kelime ile filtrele</ItemTitle>
          <StyledInput
            placeholder={"Alan adı veya şehir girin."}
            onChange={onFilterSearchTermChange}
            value={filterSearchTerm}
          />
        </FilterSection>

        <FilterSection>
          <ItemTitle>Olanaklar</ItemTitle>
          <CheckboxContainer>
            {filterData.facilities.map((attribute: any) => (
              <Checkbox
                key={attribute.id}
                value={attribute.isSelected}
                label={attribute.title}
                onChange={() => onCheckboxChange(attribute, "facilities")}
              />
            ))}
          </CheckboxContainer>
        </FilterSection>

        <FilterSection>
          <ItemTitle>Bölgeler</ItemTitle>
          <CheckboxContainer>
            {filterData.region.map((reg: any) => (
              <Checkbox
                key={reg.id}
                value={reg.isSelected}
                label={reg.title}
                onChange={() => onCheckboxChange(reg, "region")}
              />
            ))}
          </CheckboxContainer>
        </FilterSection>

        <FilterSection>
          <ItemTitle>Kategoriler</ItemTitle>
          <CheckboxContainer>
            {filterData.category.map((cat: any) => (
              <Checkbox
                key={cat.id}
                value={cat.isSelected}
                label={cat.title}
                onChange={() => onCheckboxChange(cat, "category")}
              />
            ))}
          </CheckboxContainer>
        </FilterSection>
      </ContentContainer>
      <FooterContainer>
        <ClearFilterButton onClick={clearFilter}>
          Tümünü Temizle
        </ClearFilterButton>
        <FooterButton onClick={applyFilterHandler}>Sonuçları Göster</FooterButton>
      </FooterContainer>
    </Modal>
  );
};

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 10px;
  border-bottom: 1px solid rgb(235, 235, 235) !important;
  padding: "0px 20px";
`;

const ContentContainer = styled.div`
  padding: 0px 24px 28px 24px;
  height: calc(75vh - 150px);
  @media (max-width: ${(props) => props.theme.size.mobileL}) {
    height: 80%;
  }
  @media (max-width: ${(props) => props.theme.size.tablet}) {
    height: calc(100vh - 185px);
  }

  @media (max-width: ${(props) => props.theme.size.mobileM}) {
    height: calc(100vh - 200px);
  }
  overflow-x: auto;
  // -ms-overflow-style: none;
  // scrollbar-width: none;
  &::-webkit-scrollbar {
    // display: none;
  }
`;

const StyledInput = styled.input`
  outline: none;
  border: none;
  margin: 32px 0px 0px 0px;
  width: 100%;
`;

const FooterContainer = styled.div`
  padding: 20px;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid rgb(235, 235, 235) !important;
  // @media (max-width: ${(props) => props.theme.size.mobileL}) {
  //   flex-direction: column;
  //   justify-content: center;
  //   align-items: center;
  //   padding: 10px;
  // }
`;

const FooterButton = styled.div`
  text-align: center;
  cursor: pointer;
  font-size: 16px;
  line-height: 20px;
  font-weight: 600;
  border-radius: 8px;
  outline: none;
  padding: 12px 24px;
  background: rgb(34, 34, 34);
  color: rgb(255, 255, 255);
`;

const ClearFilterButton = styled.div`
  cursor: pointer;
  margin: 0px -10px;
  font-size: 16px;
  line-height: 20px;
  font-weight: 600;
  border-radius: 8px;
  outline: none;
  padding: 10px;
  background: transparent;
  color: rgb(34, 34, 34);
  text-decoration: underline;
  @media (max-width: ${(props) => props.theme.size.mobileL}) {
    margin-bottom: 10px;
  }
`;

const FilterSection = styled.div`
  padding: 30px 0px 20px 0px;
  border-bottom: 1px solid rgb(235, 235, 235) !important;
  &:last-child {
    border-bottom: none !important;
  }
`;

const CheckboxContainer = styled.div`
  margin-top: 24px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0px, 1fr));
  grid-gap: 10px;
  @media (max-width: ${(props) => props.theme.size.mobileL}) {
    grid-template-columns: repeat(1, minmax(0px, 1fr));
  }
`;

const ItemTitle = styled.span`
  font-size: 24px;
  font-weight: inherit;
  line-height: inherit;
  margin: 0px;
  padding: 0px;
  color: ${(props) => props.theme.main.primary};
`;

const HeaderTitle = styled.span`
  color: rgb(34, 34, 34);
  font-size: 16px;
  line-height: 20px;
  font-weight: 800;
`;

const CloseIcon = styled(FontAwesomeIcon)`
  width: 30px;
  height: 30px;
  cursor: pointer;
  padding: 5px 5px;
`;

const Gap = styled.div``;

export default Filter;
